




























































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import { Classified } from "../../interfaces/classified/Classified.interface";
import { CustomIntersectionObserver } from "../../interfaces/IntersectionObserver.interface";
import iwFlags from "../Flags.vue";
import { mapActions } from "vuex";

export default Vue.extend({

    components: {
        iwFlags: iwFlags
    },
    props: {
        item: {
            type: Object,
            required: false,
            default: {} as Classified
        },
        cardTitleLinkId: {
            type: String,
            required: false,
            default: ""
        },
        target: {
            type: String,
            required: false,
            default: ""
        },
        focusable: {
            type: Boolean,
            required: false,
            default: true
        },
        cardSize: {
            type: String,
            required: false,
            default: "large"
        },
        position: {
            type: Number,
            required: false,
            default: null
        }
    },
    data: function() {
        return {
            classified: {} as Classified,
            uniqueId: uuidv4() as string
        };
    },
    computed: {
        flags: function (): string[] {
            if(this.classified !== null && this.classified.status === "DRAFT") {
                return ["to_complete"];
            } else {
                return ["waiting_payment"];
            }
        },
        price: function(): string {
            let price = this.$t("no_price") as string;

            if(this.classified !== null) {
                if(this.classified.transaction) {
                    if(this.classified.transaction.sale) {
                        if(this.classified.transaction.sale.price && this.classified.transaction.sale.price !== "") {
                            price = this.formatCurrency(this.classified.transaction.sale.price.toString());
                        }
                    }
                    if(this.classified.transaction.rental) {
                        if(this.classified.transaction.rental.monthlyRentalPrice) {
                            price = this.formatCurrency(this.classified.transaction.rental.monthlyRentalPrice.toString());
                        }
                    }
                }
            }

            return price;
        },
        creationDate: function(): string {
            let creationDate = "" as string;
            if(this.classified.creationDate && this.classified.creationDate !== "") {
                creationDate = this.formatDate(this.classified.creationDate);
            }
            return creationDate;
        },
        lastActionDate: function(): string {
            let lastActionDate = "" as string;
            if(this.classified.lastActionDate && this.classified.lastActionDate !== "") {
                lastActionDate = this.formatDate(this.classified.lastActionDate);
            }
            return lastActionDate;
        },
        transactionType: function (): string {
            let transactionType = "" as string;

            if(this.classified !== null) {
                if(this.classified.transaction) {
                    transactionType = this.classified.transaction.type;

                    if(this.classified.transaction.type !== "") {
                        if(this.classified.transaction.type === "FOR_SALE") {
                            transactionType = "to_buy";
                        }
                        if(this.classified.transaction.type === "FOR_RENT") {
                            transactionType = "to_rent";
                        }
                    }
                }
            }

            return transactionType;
        },
        propertyType: function (): string {
            let propertyType = "" as string;

            if(this.classified !== null) {
                if(this.classified.property) {
                    if(this.classified.property.subtype && this.classified.property.subtype !== "") {
                        propertyType = this.classified.property.subtype.toLowerCase();
                    } else {
                        propertyType = (this.classified.property.type && this.classified.property.type !== "") ? this.classified.property.type.toLowerCase() : "property";
                    }
                }
            }

            return propertyType;
        },
        classifiedPlaceholder: function (): string {
            return require("../../../assets/images/artworks/placeholder_card.svg");
        }
    },
    beforeMount: function() {
        this.classified = this.item as Classified;
    },
    mounted: function () {
        Vue.nextTick(() => {
            // Check if element is visible using IntersectionObserver
            // Should probably be polyfilled (https://caniuse.com/#search=IntersectionObserver)
            if("IntersectionObserver" in window) {
                let lazyBackgroundObserver = new IntersectionObserver((entries) => {

                    const entry = entries[0];

                    if (entry.isIntersecting) {
                        lazyBackgroundObserver.unobserve(entry.target);

                        let cardMediaPicture = document.createElement("img");
                        let cardMediaContainer = document.getElementById(`cardMediaContainer-${this.uniqueId}`);

                        cardMediaPicture.onload = function () {
                            cardMediaPicture.classList.add("card__media-picture--loaded");
                        };

                        cardMediaPicture.classList.add("card__media-picture");
                        cardMediaPicture.alt = this.$t("property_image") as string;

                        if (this.classified !== null) {
                            if (this.classified.pictures && this.classified.pictures[0] && this.classified.pictures[0].url) {
                                cardMediaPicture.src = this.classified.pictures[0].url;
                            } else {
                                cardMediaPicture.src = this.classifiedPlaceholder;
                                cardMediaPicture.classList.add("card--result__media-picture--placeholder");
                                if (cardMediaContainer !== null) {
                                    cardMediaContainer.classList.add("card__media-container--placeholder");
                                }
                            }
                        }
                        if (cardMediaContainer !== null) {
                            cardMediaContainer.appendChild(cardMediaPicture);
                        }
                    }
                }, {
                    threshold: 0.05,
                }) as CustomIntersectionObserver;

                // Increase POLL INTERVAL for polyfill
                // Fix issue on IOS Safari with intersection Observer not working only looking for dom-change and scroll
                // https://github.com/w3c/IntersectionObserver/tree/master/polyfill#configuring-the-polyfill
                lazyBackgroundObserver.POLL_INTERVAL = 100;
                lazyBackgroundObserver.observe(this.$el);
            }
        });
    },

    methods: {
        fullLink: function(id: string) {
            // Remove old pricing data. transaction.duration/configuredPacks can hold a tariff/pack
            // list priced for a default preview classified (e.g. Welcome.vue's landing-page preview);
            // left in place, Pricing.vue's "already loaded" guard skips repricing for this classified.
            this.$store.commit("FormModule/deleteValueTransaction", "transaction.pricing");
            this.$store.commit("FormModule/deleteValueTransaction", "transaction.duration");
            this.$store.commit("FormModule/deleteValueTransaction", "transaction.configuredPacks");

            if(this.$store.getters["MyClassifiedsModule/getClassifiedById"](id)) {
                let urlTranslated = this.$t("step-property-type") as string;
                const to = this.$router.resolve({path: urlTranslated + id });
                this.$router.push(to.location);
            }
        },
        formatDate: function(dateString: string) {
            let dateObject = new Date(dateString);
            return dateObject.toLocaleDateString("fr-BE");
        }
    }
});

